<h2 mat-dialog-title>Download to File Server</h2>
<mat-dialog-content>

  <div style="margin-bottom: 20px;">
    <span>Tell us where to store the archived files.</span>
  </div>
  <div style="display: flex; gap: 10px; margin: 6px 0;">
    <mat-form-field appearance="outline" style="width: 135px;">
      <mat-label>File Server</mat-label>
      <mat-select [(ngModel)]="fileServer">
        <mat-option value="austin">Austin</mat-option>
        <mat-option value="amazon">Amazon</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" class="custom-infix-padding" style="width: 410px;">
      <mat-label>Folder Path</mat-label>
      <input matInput [(ngModel)]="folderPath" placeholder="<driveLetter>:\<folder> (IE: D:\Processing_Files\Upload_Folder)" />
    </mat-form-field>
  </div>

</mat-dialog-content>
<mat-dialog-actions style="place-content: stretch flex-end; align-items: stretch; flex-direction: row; box-sizing: border-box; display: flex;">
  <button mat-raised-button color="primary" (click)="startDownload()">Ok</button>
  <button mat-raised-button color="secondary" mat-dialog-close>Cancel</button>
</mat-dialog-actions>
